import { assertNever, LoanReportingForeclosureStatus } from '@willow/types-iso';

export const formatForeclosureStatusFilterLabel = (status: LoanReportingForeclosureStatus) => {
  switch (status) {
    case 'NONE':
      return 'None';
    case 'ACTIVE':
      return 'In Foreclosure';
    case 'ON_HOLD':
      return 'Foreclosure On Hold';
    case 'COMPLETED':
      return 'Foreclosure Completed';
    default:
      return assertNever(status);
  }
};

export const formatForeclosureStatusShort = (status: LoanReportingForeclosureStatus) => {
  switch (status) {
    case 'NONE':
      return '';
    case 'ACTIVE':
      return 'In Foreclosure';
    case 'ON_HOLD':
      return 'Foreclosure On Hold';
    case 'COMPLETED':
      return 'Foreclosure Completed';
    default:
      return assertNever(status);
  }
};
